import React from "react";
import { FormattedHTMLMessage } from "react-intl";
import { FormSelectChoice } from "@/lib/types/types";

interface SelectListProps {
  getItemProps: any;
  highlightedIndex: number;
  itemToString: any;
  options: FormSelectChoice[];
}

const ROW_HEIGHT = 42;

const SelectList = ({ getItemProps, highlightedIndex, options, itemToString }: SelectListProps) => {
  const fullHeight = options.length * ROW_HEIGHT;

  const optionWithItemProps = (item: FormSelectChoice, index: number) => (
    <div
      className={`sid-select-list__item ${
        highlightedIndex === index ? "sid-select-list__item--highlighted" : ""
      }`}
      key={index}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...getItemProps({
        index,
        item,
      })}
    >
      {itemToString(options[index])}
    </div>
  );

  if (!options || options.length === 0) {
    return (
      <div className="sid-select-list__message">
        <FormattedHTMLMessage id="noOptions" defaultMessage="No Options" />
      </div>
    );
  }

  return (
    <div className="sid-input-select-list__menu" style={{ height: Math.min(fullHeight, 280) }}>
      {options.map((option, index) => optionWithItemProps(option, index))}
    </div>
  );
};

export const SelectListComponent = SelectList;
